import { DateUtil } from '../../util/date.util';
import { OrganizationTag } from '../organization/organization-tag.model';
import { ApplicantDetails } from './applicant-details.model';
import { OrganizationDetails } from './organization-details.model';
import { OwnershipClaimStatus } from './ownership-claim-status.enum';

export class OwnershipClaim {
  public id: string;
  public createdAt: Date;
  public organization: OrganizationTag;
  public applicantDetails: ApplicantDetails;
  public organizationDetails: OrganizationDetails;
  public status: OwnershipClaimStatus;

  constructor(data: any = {}) {
    this.id = data?.id ?? '';
    this.createdAt = data?.createdAt;
    this.organization = data?.organization ?? new OrganizationTag();
    this.applicantDetails = data?.applicantDetails ?? new ApplicantDetails();
    this.organizationDetails = data?.organizationDetails ?? new OrganizationDetails();
    this.status = data?.status ?? '';
  }

  public static createFromApi(data: any = {}): OwnershipClaim {
    const organization: OrganizationTag = OrganizationTag.createFromApi(data?.organization);
    const applicantDetails: ApplicantDetails = ApplicantDetails.createFromApi(data?.data?.applicantDetails);
    const organizationDetails: OrganizationDetails = OrganizationDetails.createFromApi(data?.data?.organizationDetails);

    return new OwnershipClaim({
      id: data?.id ?? '',
      createdAt: DateUtil.createOrInitialise(data?.createdAt),
      organization,
      applicantDetails,
      organizationDetails,
      status: data?.status ?? '',
    });
  }

  public processForApi(): Record<string, any> {
    return {
      organization: this.organization.processForApi(),
      applicantDetails: this.applicantDetails.processForApi(),
      organizationDetails: this.organizationDetails.processForApi(),
    };
  }
}
